module.exports = __webpack_public_path__ + "static/media/facebook_black.ef226d3d.svg";